import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { VIRTUAL_TOGGLE_FILTERS } from '@sorare/core/src/lib/filters';

import type {
  UpdateSavedFiltersMutation,
  UpdateSavedFiltersMutationVariables,
} from './__generated__/updateCardFilters.graphql.ts';

export type CardFilters = {
  query?: string;
  refinementList?: Record<string, string[]>;
  range?: Record<string, string>;
  toggle?: Record<string, boolean>;
  virtualToggle?: Record<string, string | boolean>;
  menu?: Record<string, string>;
};

export const UPDATE_SAVED_FILTERS_MUTATION = gql`
  mutation UpdateSavedFiltersMutation(
    $input: updateCardFiltersInput!
    $sport: Sport!
  ) {
    updateCardFilters(input: $input) {
      currentUser {
        slug
        cardFilters(sport: $sport)
      }
      errors {
        code
        message
      }
    }
  }
` as TypedDocumentNode<
  UpdateSavedFiltersMutation,
  UpdateSavedFiltersMutationVariables
>;

export const toTrackingFilters = (
  filters: CardFilters
): Record<string, string> => {
  const flattenFilters = {
    ...(filters.query ? { query: filters.query } : {}),
    ...Object.values({
      refinementList: filters.refinementList,
      range: filters.range,
      toggle: filters.toggle,
      virtualToggle: filters.virtualToggle,
      menu: filters.menu,
    }).reduce<Record<string, string | string[] | boolean>>(
      (acc, value) => ({ ...acc, ...value }),
      {}
    ),
  };

  return Object.fromEntries(
    Object.entries(flattenFilters).map(([filterName, value]) => {
      const matchingVirtualToggle = Object.values(VIRTUAL_TOGGLE_FILTERS).find(
        ({ name: virtualToggleName }) => virtualToggleName === filterName
      );

      return [
        matchingVirtualToggle?.trackingName || filterName,
        value.toString(),
      ];
    })
  );
};
